import { render, staticRenderFns } from "./CriterionComparativeTable.vue?vue&type=template&id=5c1e1448&scoped=true&"
import script from "./CriterionComparativeTable.vue?vue&type=script&lang=js&"
export * from "./CriterionComparativeTable.vue?vue&type=script&lang=js&"
import style0 from "./CriterionComparativeTable.vue?vue&type=style&index=0&id=5c1e1448&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e1448",
  null
  
)

export default component.exports